<template>
    <div class="modal fade" id="EnableProductAvailabilityAlert" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-xs modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">ثبت شماره موبایل</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="content-section default">
                                <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                                    <li v-for="error in errors.all()">{{ error }}</li>
                                </ul>
                                <form @submit.prevent="addEnableProductAvailabilityAlert" class="form-account">
                                    <div class="row">

                                        <div class="col-12 col-sm-12 col-md-12 pull-right">
                                            
                                                <div class="form-account-title"> شماره موبایل</div>
                                                <div class="form-account-row">
                                                    <input v-model="TelNumber"
                                                           v-validate="{ required: true, regex: /^0\d{10}$/ }"
                                                           data-vv-as="شماره موبایل" class="input-field"
                                                           placeholder="شماره موبایل خود را وارد کنید">
                                                </div>
                                            
                                        </div>

                                        <div class="col-12 col-sm-12 col-md-12 text-center">
                                            <button type="submit"
                                                    class="btn btn-default btn-lg btn-save">
                                                ذخیره
                                            </button>
                                            <button data-dismiss="modal"
                                                    class="btn btn-default btn-lg btn-reject">
                                                انصراف
                                            </button>
                                        </div>
                                    </div>


                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="{ loader: !isShowLoader, 'loader-bg-black': true }">
                    <img src="/assets/img/loader/loader.svg" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import { httpPromise } from "../../module/httpUtility";



    export default {
        data() {
            return {
                TelNumber: "",
                isShowLoader :false
            }
        },
        created() {
            //citySelectorEventBus.$on('cityOnSelected', (data) => {
            //    this.cityFullName = data.cityFullName;
            //    this.addressInfo.CityId = data.cityId;
            //});
            //var setUserInfoToForm = this.setUserInfoToForm;
            //var resetForm = this.resetForm;
            //$(function () {
            //    $('#addAddressModal').on("hidden.bs.modal", function (event) {
            //        resetForm();
            //    });
            //    $('#addAddressModal').on("shown.bs.modal", function (event) {
            //        setUserInfoToForm();
            //    });
            //});
        },
        beforeDestroy() {
           /* citySelectorEventBus.$off('cityOnSelected');*/
        },
        methods: {
            openCitySelectorModal: function () {
                $(function () {
                    $('#citySelectorModal').modal({ backdrop: 'static', keyboard: false });
                    $('#citySelectorModal').modal('show');
                });
            },
            setUserInfoToForm() {
                this.transfereeMobNo = this.userMobNo;
                this.transfereeName = this.userFullName;
            },
            resetForm() {
                this.addressInfo = { CityId: null };
              /*  this.cityFullName = '';*/

                this.$validator.reset();
                this.$validator.errors.clear();
            },
            addEnableProductAvailabilityAlert() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        httpPromise(this, '/v1/ProductManagement/CustomerProductAvailability/IsExist', 'post', { CustomerMobNo: this.TelNumber, productId: window.location.href.split("/")[4] },
                            response => {
                                toastr.remove();
                                if (response.data.Value) {
                                    toastr.error("شما این محصول را اضافه کرده اید");
                                } else {
                                    httpPromise(this, '/v1/ProductManagement/CustomerProductAvailability/Add', 'post', { CustomerMobNo: this.TelNumber, productId: window.location.href.split("/")[4] },
                                        response => {
                                            toastr.remove();
                                            if (response.data.IsSuccess) {
                                                toastr.success("شماره تماس شما اضافه شد . در صورت موجود شدن به شما اطلاع داده میشود");

                                            }
                                            this.isShowLoader = false;
                                            $(function () {
                                                $('#addAddressModal').modal('hide');
                                                window.location.reload();
                                            });
                                        },
                                        response => {
                                            toastr.remove();
                                            toastr.error(response.data.Message);
                                            this.isShowLoader = false;
                                        });
                                }
                                this.isShowLoader = false;
                                this.TelNumber = "";
                                $(function () {
                                    $('#EnableProductAvailabilityAlert').modal('hide');
                                });

                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowLoader = false;
                            });
                    }
                });
            },
        },

    }
</script>

<style scoped>
    .loader-bg-black {
        position: absolute;
        background-color: #80808033;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        width: 100%;
        height: 100%
    }

        .loader-bg-black img {
            position: absolute;
            top: 50%;
            left: 48%;
            z-index: 100
        }

    .btn-save {
        background-color: #59b959 !important;
    }

    .btn-reject {
        background-color: #e36e6e !important;
    }

    .input-field {
        padding: 11px 11px 11px 11px !important;
    }

    .modal-content .modal-header button {
        right: unset !important;
        left: 27px !important;
        top: 30px !important;
    }

    .modal-header .close {
        padding: unset !important;
        margin: -1rem -1rem -1rem auto;
    }

    .setaddress {
        padding: 22px !important;
    }

    a:not([href]):not([tabindex]) {
        color: #fff;
    }

    .box.profile .center {
        text-align: center;
    }

    .box.no-address .desc {
        display: block;
        margin: 0 auto;
    }

    .box.profile.no-address img {
        margin-bottom: 25px;
    }

    .box.no-address {
        text-align: center;
        color: #777777;
    }

    .address-div {
        display: contents;
    }

    .box profile {
        min-height: 200px;
        width: auto;
    }

    .box {
        background: #fcfcfc;
        border: 1px solid #e5e5e5;
        -webkit-border-radius: 5px;
        border-radius: 5px;
        padding: 15px;
        width: 100%;
        margin-top: 15px;
    }

        .box .title {
            display: block;
            font-weight: 500;
            text-align: center;
        }

        .box .location {
            font-size: 12px;
            color: #777777;
            display: block;
            text-align: center;
            margin-top: 5px;
        }

        .box .desc {
            margin-top: 15px;
            text-align: center;
            display: block;
            font-size: 12px;
        }

        .box.profile .center {
            text-align: center;
        }

    .btn-lg {
        padding: 10px 25px;
    }
</style>